import type { VariationTypeExtension } from "@/core/api/graphql/types";

const hasWarehouseStock = (variation: VariationTypeExtension, warehouseName: string) => {
  return (
    variation.availabilityData.inventories?.find(
      (i) =>
        i.fulfillmentCenterName?.toLocaleLowerCase().includes(warehouseName.toLocaleLowerCase()) &&
        i.inStockQuantity > 0,
    ) !== undefined
  );
};

export const hasGlobalStock = (variation: VariationTypeExtension, currencyCode: string): boolean => {
  if (!variation) {
    return false;
  }

  let isInGlobalStock = false;
  switch (currencyCode) {
    case "USD":
      isInGlobalStock = hasWarehouseStock(variation, "MUC") || hasWarehouseStock(variation, "JPN");
      break;
    case "EUR":
    case "GBP":
    case "SEK":
      isInGlobalStock = hasWarehouseStock(variation, "THO") || hasWarehouseStock(variation, "JPN");
      break;
    case "CNY":
      isInGlobalStock =
        hasWarehouseStock(variation, "THO") ||
        hasWarehouseStock(variation, "MUC") ||
        hasWarehouseStock(variation, "JPN");
      break;
    case "JPY":
      isInGlobalStock = hasWarehouseStock(variation, "THO") || hasWarehouseStock(variation, "MUC");
      break;
    case "BRL":
      isInGlobalStock = hasWarehouseStock(variation, "MUC") || hasWarehouseStock(variation, "JPN");
      break;
  }

  return isInGlobalStock;
};
